export default "__VITE_ASSET__MqcAU4pD__"